import React from "react";
import {
  Row,
  Form,
  FormGroup,
  Button,
  FormControl,
  Alert,
  Col,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  createQboAccount,
  createQboBill2,
  createQboCustomer,
  createQboExpense2,
  createQboInvoice2,
  createQboVendor,
  getJobTransactions,
  getQboCustomers,
  updateJobTransaction,
} from "../../../docuclipper/api";
import { Invoice2 } from "../../../docuclipper/DocuclipperTypes";
import { ReduxState } from "../../../redux";
import {
  fetchTls,
  setSelectedDocumentId,
  setSelectedRowNumber,
} from "../../../redux/reducers/TransactionManager";
import { Field, Formik, FieldArray, ErrorMessage } from "formik";
import {
  formikCheckInput,
  formikTextArea,
  formikInput,
  formikArrayInput,
  formikSelectInput,
  isNullOrUndefined,
  capitalize,
} from "../../../utils/utils";
import * as Yup from "yup";
import { createAlert } from "../../../redux/reducers/Alerts";
import { fetchIntegrations } from "../../../redux/reducers/Integration";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  addQboCustomer,
  fetchQboCustomers,
} from "../../../redux/reducers/QboCustomer";
import {
  addQboAccount,
  fetchQboAccounts,
} from "../../../redux/reducers/QboAccount";

import ClipLoader from "react-spinners/ClipLoader";
import excelIcon from "../../../icons/excel.png";
import { ExportTypeDropdown } from "../DataArchive/TransactionManager/DownloadOptions/ExportTypeDropdown";
import { downloadSpreadsheetHelper } from "../DataArchive/TransactionManager/DownloadOptions/utils";
import {
  addQboVendor,
  fetchQboVendors,
} from "../../../redux/reducers/QboVendor";
import { FormikQboSelect } from "./QboSelect";
import { goToQuickbooksFn } from "../Integrations/IntegrationsTable";

import quickbooksConnectIcon from "../../../icons/C2QB_green_btn_med_default.svg";
import { useLocation } from "react-router-dom";
import { groupBy, uniq } from "lodash";

type Props = {};
export const ExportQboInvoice: React.FC<Props> = ({ }) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const { job } = useSelector((state: ReduxState) => state.JobData);
  const { tls, selectedDocumentId, selectedRowNumber } = useSelector(
    (state: ReduxState) => state.TransactionManager
  );
  const exportTo = useSelector(
    (state: ReduxState) => state.DownloadOptions.selectedExportType
  );

  const { qboCustomers, loading: qboCustomersLoading } = useSelector(
    (state: ReduxState) => state.QboCustomer
  );

  const { qboVendors, loading: qboVendorsLoading } = useSelector(
    (state: ReduxState) => state.QboVendor
  );

  const { qboAccounts, loading: qboAccountsLoading } = useSelector(
    (state: ReduxState) => state.QboAccount
  );

  const { integrations, loading: integrationsLoading } = useSelector(
    (state: ReduxState) => state.Integration
  );

  const fullPath = location.pathname + location.search;
  const [docType, setDocType] = React.useState<"invoice" | "bill" | "expense">(
    "expense"
  );
  const [ctaLoading, setCtaLoading] = React.useState(false);
  const qboIntegrations = integrations.filter(
    (i) => i.scope === "intuit.quickbooks.accounting"
  );
  React.useEffect(() => {
    dispatch(fetchTls(true));
  }, []);

  React.useEffect(() => {
    dispatch(fetchIntegrations());
  }, []);

  React.useEffect(() => {
    if (qboIntegrations.length > 0) {
      dispatch(fetchQboCustomers(qboIntegrations[0].id));
      dispatch(fetchQboVendors(qboIntegrations[0].id));
      dispatch(fetchQboAccounts(qboIntegrations[0].id));
    }
  }, [qboIntegrations.length]);

  if (tls.tls.length === 0) {
    return null;
  }

  const selectedTl =
    !isNullOrUndefined(selectedDocumentId) &&
      !isNullOrUndefined(selectedRowNumber)
      ? tls.tls.filter((x) => x.documentId === selectedDocumentId)[
      selectedRowNumber as number
      ]
      : null;

  const invoice: Invoice2 = selectedTl
    ? JSON.parse(selectedTl.row as any)
    : null;

  if (!invoice) {
    return null;
  }

  // https://formik.org/docs/examples/field-arrays

  // return (
  //   <>
  //     {customers.map((c) => (
  //       <div>{JSON.stringify(c)}</div>
  //     ))}
  //   </>
  // );

  const validationSchema = Yup.object().shape({
    id: Yup.string(),
    date: Yup.string()
      .trim()
      .matches(/\d{4}\-\d{2}\-\d{2}/, "Invalid date, use YYYY-MM-DD format")
      .required(),
    dueDate: Yup.string()
      .trim()
      .matches(/\d{4}\-\d{2}\-\d{2}/, "Invalid date, use YYYY-MM-DD format"),
    total: Yup.number(),
    tax: Yup.number(),
    lines: Yup.array().of(
      Yup.object().shape({
        item: Yup.string(),
        // .required("Item is required"),
        quantity: Yup.number().typeError("Quantity must be a number"),
        // .required("Quantity is required"),
        unitPrice: Yup.number().typeError("Unit Price must be a number"),
        // .required("Unit price is required"),
        price: Yup.number().typeError("Price must be a number"),
        // .required("Price is required"),
      })
    ),
    // .min(1, "Need at least a friend"),
  });
  if (exportTo === "qbo") {
    (validationSchema as any).integration = Yup.string().required(
      "QuickBooks Company is required"
    );
    if (docType === "invoice") {
      (validationSchema as any).customer = Yup.string().required(
        "QuickBooks Customer is required"
      );
    } else if (docType === "bill") {
      (validationSchema as any).vendor = Yup.string().required(
        "QuickBooks Vendor is required"
      );
      (validationSchema as any).account = Yup.string().required(
        "QuickBooks Account is required"
      );
    } else if (docType === "expense") {
      (validationSchema as any).account = Yup.string().required(
        "QuickBooks Account is required"
      );
    }
  }

  const { documents } = tls;

  const getName = (documentId) => {
    const x = documents.filter((x) => x.id === documentId);
    if (x && x.length > 0) {
      return x[0].originalname;
    }

    return documentId;
  };

  const tlsByDocId = groupBy(tls.tls, "documentId");
  return (
    <div>
      <div className="mx-2">
        <Alert variant="info">
          We just added support for converting invoices and receipts. Email{" "}
          <a href="mailto:support@docuclipper.com">support@docuclipper.com</a>{" "}
          if you run into any issues or have feedback.
        </Alert>
      </div>
      <Row>
        <Col md="4">
          <>
            <div
              className="m-4 transaction-manager-documents"
              style={{ overflow: "scroll", maxHeight: "75vh" }}
            >
              <div className="font-weight-bold my-4 h3">Documents</div>
              {(Object.keys(tlsByDocId) || [])
                // .sort((a, b) => a.documentId.localeCompare(b.documentId))
                .map((docId, i) => (
                  <>
                    {/* <Form.Check
                      type="radio"
                      // className={
                      //   value && option.value === value.value ? "font-weight-bold" : ""
                      // }
                      checked={
                        !!selectedDocumentId &&
                        tlsByDocId[docId][0].documentId === selectedDocumentId
                      }
                      label={getName(tlsByDocId[docId][0].documentId)}
                      // label={i}
                      onChange={(e) => {
                        dispatch(
                          setSelectedDocumentId(
                            tlsByDocId[docId][0].documentId as any
                          )
                        );
                      }}
                    /> */}
                    <div className="font-weight-bold">
                      {getName(tlsByDocId[docId][0].documentId)}
                    </div>
                    {tlsByDocId[docId].map((tl, j) => (
                      <Form.Check
                        type="radio"
                        // className={
                        //   value && option.value === value.value ? "font-weight-bold" : ""
                        // }
                        checked={
                          !!selectedDocumentId &&
                          tl.documentId === selectedDocumentId &&
                          !isNullOrUndefined(selectedRowNumber) &&
                          selectedRowNumber === j
                        }
                        label={(j + 1).toString()}
                        // label={i}
                        onChange={(e) => {
                          dispatch(setSelectedDocumentId(tl.documentId));
                          dispatch(setSelectedRowNumber(j));
                        }}
                      />
                    ))}
                  </>
                ))}
            </div>
          </>
        </Col>
        <Col md="8">
          <Formik
            enableReinitialize={true}
            initialValues={{
              id: invoice.id,
              integration:
                qboIntegrations.length > 0 ? qboIntegrations[0].id : null,
              date: invoice.date || "",
              dueDate: invoice.dueDate || "",
              total: invoice.total,
              tax: invoice.tax,
              lines: invoice.lines || [],
              customer: qboCustomers
                ? qboCustomers.length > 0
                  ? qboCustomers[0].value
                  : ""
                : "",
              vendor: qboVendors
                ? qboVendors.length > 0
                  ? qboVendors[0].value
                  : ""
                : "",
              account: qboAccounts
                ? qboAccounts.length > 0
                  ? qboAccounts[0].value
                  : ""
                : "",
            }}
            validationSchema={validationSchema}
            onSubmit={(values, helpers) => {
              //

              const { id, date, dueDate, total, lines, integration, tax } =
                values;
              const invoice: Invoice2 = {
                id,
                date,
                dueDate,
                lines,
                total,
                tax,
              };

              if (job && selectedTl && selectedDocumentId) {
                updateJobTransaction(job?.id, selectedTl.id as any, {
                  newValue: JSON.stringify(invoice),
                })
                  .then(() => {
                    if (exportTo === "qbo") {
                      // TODO add customer dropdown
                      if (docType === "invoice") {
                        const c = qboCustomers.filter(
                          (x) => x.value === values.customer
                        );
                        if (!isNullOrUndefined(integration) && c.length > 0) {
                          setCtaLoading(true);
                          createQboInvoice2(
                            integration as any,
                            selectedTl.id as any,
                            c[0]
                          )
                            .then((invoice) => {
                              setCtaLoading(false);
                              dispatch(
                                createAlert({
                                  message: "Invoice created successfully",
                                  timeout: 0,
                                  type: "success",
                                })
                              );
                            })
                            .catch((err) => {
                              setCtaLoading(false);
                              dispatch(
                                createAlert({
                                  message:
                                    err.message || "Error creating invoice",
                                  timeout: 0,
                                  type: "error",
                                })
                              );
                            });
                        }
                      } else if (docType === "bill") {
                        const v = qboVendors.filter(
                          (x) => x.value === values.vendor
                        );
                        const a = qboAccounts.filter(
                          (x) => x.value === values.account
                        );
                        if (
                          !isNullOrUndefined(integration) &&
                          v.length > 0 &&
                          a.length > 0 &&
                          selectedTl
                        ) {
                          setCtaLoading(true);
                          createQboBill2(
                            integration as any,
                            selectedTl.id as any,
                            v[0],
                            a[0]
                          )
                            .then((bill) => {
                              setCtaLoading(false);
                              dispatch(
                                createAlert({
                                  message: "Bill created successfully",
                                  timeout: 0,
                                  type: "success",
                                })
                              );
                            })
                            .catch((err) => {
                              setCtaLoading(false);
                              dispatch(
                                createAlert({
                                  message: err.message || "Error creating bill",
                                  timeout: 0,
                                  type: "error",
                                })
                              );
                            });
                        }
                      } else if (docType === "expense") {
                        const a = qboAccounts.filter(
                          (x) => x.value === values.account
                        );
                        if (
                          !isNullOrUndefined(integration) &&
                          a.length > 0 &&
                          selectedTl
                        ) {
                          setCtaLoading(true);
                          createQboExpense2(
                            integration as any,
                            selectedTl.id as any,
                            a[0]
                          )
                            .then((expense) => {
                              setCtaLoading(false);
                              dispatch(
                                createAlert({
                                  message: "Expense created successfully",
                                  timeout: 0,
                                  type: "success",
                                })
                              );
                            })
                            .catch((err) => {
                              setCtaLoading(false);
                              dispatch(
                                createAlert({
                                  message:
                                    err.message || "Error creating expense",
                                  timeout: 0,
                                  type: "error",
                                })
                              );
                            });
                        }
                      }
                    } else if (["custom-basic", "xlsx"].includes(exportTo)) {
                      downloadSpreadsheetHelper(
                        job,
                        "Invoice",
                        exportTo,
                        {
                          dateFormat: "YYYY-MM-DD",
                          fileType: exportTo.toUpperCase(),
                        },
                        // [selectedDocumentId], //selectedDocumentIds,
                        uniq((tls.tls || []).map((x) => x.documentId)),
                        [], //selectedFieldNames,
                        [],
                        'date',
                        'asc',
                        exportTo === 'xlsx' ? 'xlsx' as any : 'csv' as any,

                      );
                    }
                  })
                  .catch((err) =>
                    dispatch(
                      createAlert({
                        message: "Error updating invoice",
                        timeout: 0,
                        type: "error",
                      })
                    )
                  );
              }
            }}
          >
            {({
              submitForm,
              values,
              isValid,
              errors,
              handleChange,
              setFieldValue,
            }) => {
              let cta = "Download";
              if (["custom-basic", "xlsx"].includes(exportTo)) {
                // cta = `Download ${exportTo.toUpperCase()}`;
                // cta = `Download Excel ${exportTo} - ${tls.tls.length} ${
                //   docType === "invoice"
                //     ? "invoice(s)"
                //     : docType === "bill"
                //     ? "bills(s)"
                //     : "expense(s)"
                // }`;
                cta = `Download Excel (${exportTo === 'xlsx' ? exportTo.toUpperCase() : 'CSV'}) - ${tls.tls.length
                  } items`;
              } else if (exportTo === "qbo") {
                cta = `Import ${tls.tls.length} ${docType === "invoice"
                  ? "invoice(s)"
                  : docType === "bill"
                    ? "bills(s)"
                    : "expense(s)"
                  } into QuickBooks Online`;
              }
              return (
                <>

                  <div className="m-4">
                    <Form.Group>
                      <FormGroup>
                        <strong>
                          <Form.Label>Export To</Form.Label>
                        </strong>
                        <ExportTypeDropdown />
                      </FormGroup>
                    </Form.Group>

                    <Form.Group controlId="exampleForm.ControlSelect1">
                      <Form.Label>
                        <strong>Document Type</strong>
                      </Form.Label>
                      <Form.Control
                        as="select"
                        value={docType}
                        onChange={(e) =>
                          setDocType(
                            e.target.value as "bill" | "invoice" | "expense"
                          )
                        }
                      >
                        <option value="expense">Expense</option>
                        <option value="invoice">Invoice</option>
                        <option value="bill">Bill</option>
                      </Form.Control>
                    </Form.Group>
                    {exportTo === "qbo" && (
                      <>
                        <Row>
                          <Col>
                            {integrationsLoading && <ClipLoader />}

                            {!integrationsLoading && (
                              <Form.Group>
                                <FormGroup>
                                  <strong>
                                    <Form.Label>QuickBooks Company</Form.Label>
                                  </strong>

                                  <Field
                                    name="integration"
                                    as="select"
                                    className=""
                                    component={formikSelectInput}
                                    onChange={(e) => {
                                      setFieldValue(
                                        "integration",
                                        e.target.value
                                      );
                                      dispatch(
                                        fetchQboCustomers(e.target.value)
                                      );
                                      dispatch(fetchQboVendors(e.target.value));
                                    }}
                                  >
                                    {qboIntegrations.map((integration, i) => {
                                      let name = `Company ${i + 1}`;
                                      try {
                                        const name2 = JSON.parse(
                                          integration.extraParams
                                        );
                                        if (name2 && name2.companyName) {
                                          name = name2.companyName;
                                        }
                                      } catch (err) {
                                        //
                                      }
                                      return (
                                        <option value={integration.id}>
                                          {name}
                                        </option>
                                      );
                                    })}
                                  </Field>
                                </FormGroup>
                              </Form.Group>
                            )}
                          </Col>
                          <Col>
                            <div
                              // variant="primary"
                              // action="connectToQuickbooks"
                              className="float-right btn--add-quickbooks"
                              onClick={() =>
                                goToQuickbooksFn(
                                  `&next=${encodeURIComponent(fullPath)}`
                                )
                              }
                              style={{ cursor: "pointer", marginTop: "2rem" }}
                            >
                              <img
                                style={{ height: "36px" }}
                                src={quickbooksConnectIcon}
                                alt="QuickBooks logo"
                              />

                              {/* <CollapsibleBtnText icon="plus" text="Connect QuickBooks Company" /> */}
                            </div>
                          </Col>
                        </Row>

                        {docType === "invoice" && qboCustomersLoading && (
                          <ClipLoader />
                        )}

                        {docType === "invoice" && !qboCustomersLoading && (
                          <Form.Group>
                            <FormGroup>
                              <strong>
                                <Form.Label>QuickBooks Customer</Form.Label>
                              </strong>

                              <Field
                                name="customer"
                                placeholder="Search or create a new customer"
                                //   as="select"
                                className=""
                                component={FormikQboSelect}
                                options={qboCustomers.map((c) => ({
                                  label: c.name,
                                  value: c.value,
                                }))}
                                createFn={(value) =>
                                  createQboCustomer(
                                    values.integration as any,
                                    value
                                  ).then((c) => {
                                    dispatch(
                                      addQboCustomer({
                                        name: c.DisplayName,
                                        value: c.Id,
                                      })
                                    );
                                    return {
                                      id: c.Id,
                                      name: c.DisplayName,
                                    };
                                  })
                                }
                                type={"customer"}
                              />
                            </FormGroup>
                          </Form.Group>
                        )}
                        {docType === "bill" && qboVendorsLoading && (
                          <ClipLoader />
                        )}

                        {docType === "bill" && !qboVendorsLoading && (
                          <Form.Group>
                            <FormGroup>
                              <strong>
                                <Form.Label>QuickBooks Vendor</Form.Label>
                              </strong>

                              <Field
                                name="vendor"
                                //   as="select"
                                className=""
                                placeholder="Search or create a new vendor"
                                component={FormikQboSelect}
                                options={qboVendors.map((c) => ({
                                  label: c.name,
                                  value: c.value,
                                }))}
                                createFn={(value) =>
                                  createQboVendor(
                                    values.integration as any,
                                    value
                                  ).then((c) => {
                                    dispatch(
                                      addQboVendor({
                                        name: c.DisplayName,
                                        value: c.Id,
                                      })
                                    );
                                    return {
                                      id: c.Id,
                                      name: c.DisplayName,
                                    };
                                  })
                                }
                                type={"vendor"}
                              />
                            </FormGroup>
                          </Form.Group>
                        )}
                        {["bill", "expense"].includes(docType) &&
                          qboAccountsLoading && <ClipLoader />}

                        {["bill", "expense"].includes(docType) &&
                          !qboAccountsLoading && (
                            <Form.Group>
                              <FormGroup>
                                <strong>
                                  <Form.Label>QuickBooks Account</Form.Label>
                                </strong>

                                <Field
                                  name="account"
                                  placeholder="Search or create a new account"
                                  //   as="select"
                                  className=""
                                  component={FormikQboSelect}
                                  options={qboAccounts.map((c) => ({
                                    label: c.name,
                                    value: c.value,
                                  }))}
                                  createFn={(value) =>
                                    createQboAccount(
                                      values.integration as any,
                                      value
                                    ).then((c) => {
                                      dispatch(
                                        addQboAccount({
                                          name: c.Name,
                                          value: c.Id,
                                        })
                                      );
                                      return {
                                        id: c.Id,
                                        name: c.Name,
                                      };
                                    })
                                  }
                                  type={"account"}
                                />
                              </FormGroup>
                            </Form.Group>
                          )}
                      </>
                    )}

                    <Form.Group>
                      <FormGroup>
                        <strong>
                          <Form.Label>{`${capitalize(docType)} #`}</Form.Label>
                        </strong>
                        <Field
                          placeholder=""
                          name="id"
                          type="text"
                          component={formikInput}
                        />
                      </FormGroup>
                    </Form.Group>
                    <Form.Group>
                      <FormGroup>
                        <strong>
                          <Form.Label>{`${capitalize(
                            docType
                          )} date`}</Form.Label>
                        </strong>
                        <Field
                          placeholder=""
                          name="date"
                          type="text"
                          component={formikInput}
                        />
                      </FormGroup>
                    </Form.Group>
                    {["bill", "invoice"].includes(docType) && (
                      <Form.Group>
                        <FormGroup>
                          <strong>
                            <Form.Label>{`${capitalize(
                              docType
                            )} due date`}</Form.Label>
                          </strong>
                          <Field
                            placeholder=""
                            name="dueDate"
                            type="text"
                            component={formikInput}
                          />
                        </FormGroup>
                      </Form.Group>
                    )}
                    <Form.Group>
                      <FormGroup>
                        <strong>
                          <Form.Label>Tax</Form.Label>
                        </strong>
                        <Field
                          placeholder=""
                          name="tax"
                          type="text"
                          component={formikInput}
                        />
                      </FormGroup>
                    </Form.Group>
                    <Form.Group>
                      <FormGroup>
                        <strong>
                          <Form.Label>Total</Form.Label>
                        </strong>
                        <Field
                          placeholder=""
                          name="total"
                          type="text"
                          component={formikInput}
                        />
                      </FormGroup>
                    </Form.Group>
                    <FieldArray name="lines">
                      {({ insert, remove, push }) => (
                        <div style={{ maxHeight: "60vh", overflowY: "scroll" }}>
                          {values.lines.length > 0 &&
                            values.lines.map((friend, index) => (
                              <div className="row my-2" key={index}>
                                <div className="col">
                                  {index === 0 && (
                                    <strong>
                                      <label htmlFor={`lines.${index}.item`}>
                                        Item
                                      </label>
                                    </strong>
                                  )}
                                  <Field
                                    name={`lines.${index}.item`}
                                    placeholder=""
                                    type="text"
                                    component={formikArrayInput}
                                  />
                                  {/* <ErrorMessage
                              name={`lines.${index}.item`}
                              component="div"
                              className="field-error"
                            /> */}
                                </div>
                                <div className="col">
                                  {index === 0 && (
                                    <strong>
                                      <label
                                        htmlFor={`lines.${index}.quantity`}
                                      >
                                        Quantity
                                      </label>
                                    </strong>
                                  )}
                                  <Field
                                    name={`lines.${index}.quantity`}
                                    placeholder=""
                                    type="email"
                                    component={formikArrayInput}
                                  />
                                  {/* <ErrorMessage
                              name={`lines.${index}.quantity`}
                              component="div"
                              className="field-error"
                            /> */}
                                </div>
                                <div className="col">
                                  {index === 0 && (
                                    <strong>
                                      <label
                                        htmlFor={`lines.${index}.unitPrice`}
                                      >
                                        Unit Price
                                      </label>
                                    </strong>
                                  )}
                                  <Field
                                    name={`lines.${index}.unitPrice`}
                                    placeholder=""
                                    type="email"
                                    component={formikArrayInput}
                                  />
                                  {/* <ErrorMessage
                              name={`lines.${index}.unitPrice`}
                              component="div"
                              className="field-error"
                            /> */}
                                </div>
                                <div className="col">
                                  {index === 0 && (
                                    <strong>
                                      <label htmlFor={`lines.${index}.price`}>
                                        Price
                                      </label>
                                    </strong>
                                  )}
                                  <Field
                                    name={`lines.${index}.price`}
                                    placeholder=""
                                    type="email"
                                    component={formikArrayInput}
                                  />
                                  {/* <ErrorMessage
                              name={`lines.${index}.price`}
                              component="div"
                              className="field-error"
                            /> */}
                                </div>
                                <div
                                  className="col"
                                  style={{
                                    marginTop: index === 0 ? "2rem" : "",
                                  }}
                                >
                                  <Button
                                    variant="link"
                                    className="secondary"
                                    onClick={() => remove(index)}
                                  >
                                    <FontAwesomeIcon icon="trash"></FontAwesomeIcon>
                                    <span className="ml-1">
                                      Delete Line Item
                                    </span>
                                  </Button>
                                </div>
                              </div>
                            ))}

                          <Button
                            variant="link"
                            className="secondary"
                            onClick={() =>
                              push({
                                item: "",
                                quantity: "",
                                unitPrice: "",
                                price: "",
                              })
                            }
                          >
                            <FontAwesomeIcon icon="plus"></FontAwesomeIcon>
                            <span className="ml-1">Add Line Item</span>
                          </Button>
                        </div>
                      )}
                    </FieldArray>
                  </div>
                  <Row className="justify-content-end">
                    {ctaLoading && <ClipLoader />}
                    {!ctaLoading && (
                      <Button
                        className="mx-4  btn--still-want-cancel"
                        variant="primary"
                        onClick={() => {
                          submitForm();
                        }}
                      // disabled={!feedback}
                      >
                        {cta}
                      </Button>
                    )}
                  </Row>
                </>
              );
            }}
          </Formik>
        </Col>
      </Row>
    </div>
  );
};
export default ExportQboInvoice;
